@if (customer) {
  <app-detail-view
    [data]="customer"
    [title]="customer.businessPartnerName || ''"
    (closeClicked)="onCloseButtonClicked()">
    <div class="flex w-full gap-4">
      <div class="flex flex-1 flex-col items-start gap-1">
        <div>{{ 'project.numberOf' | translate }}</div>
        <div>{{ customer.numberOfProjects }}</div>
      </div>
      <div class="flex flex-1 flex-col items-start gap-1">
        <div>{{ 'employee.numberOf' | translate }}</div>
        <div>{{ customer.numberOfEmployes }}</div>
      </div>
    </div>
    <gx-tabs>
      <gx-tab [caption]="'employee.plural' | translate" id="employees">
        <app-details-employee-list [customer]="customer"></app-details-employee-list>
      </gx-tab>
      <gx-tab [caption]="'project.plural' | translate" id="projects">
        <app-customer-project-list [customer]="customer"></app-customer-project-list>
      </gx-tab>
    </gx-tabs>
  </app-detail-view>
}
